import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uiActions from 'tradera-state/ui/actions';
import ProfileMenu from '../profile-menu/profile-menu';
import ProfileLink from './profile-link';
import { trackProfileClick } from './site-header.analytics';
import { useUrlLocalizer } from 'tradera-lang';

const ProfileMenuLink = props => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const handleLoginClick = (redirectUrl = false) =>
        props.signIn(toLocalizedUrl(redirectUrl));

    // Prevent Default and show login, if not logged in
    const preventNavigationAndShowLogin = (event, redirect) => {
        const {
            member: { isLoggedIn }
        } = props;
        if (!isLoggedIn) {
            event.preventDefault();
            handleLoginClick(redirect);
        }
    };

    const handleProfileClick = evt => {
        const {
            member: { isLoggedIn },
            pageName,
            profileMenu,
            openProfileMenu,
            closeProfileMenu,
            closeCategoryDropdownMenu
        } = props;

        if (profileMenu.open === 'open') {
            trackProfileClick(isLoggedIn, false);
            closeProfileMenu();
        } else {
            closeCategoryDropdownMenu();
            trackProfileClick(isLoggedIn, true);
            // not logged in
            if (!isLoggedIn) {
                preventNavigationAndShowLogin(evt, '/my/overview');
                return;
            } else {
                openProfileMenu();
            }
        }

        if (pageName.includes('MyTradera')) {
            window.scrollTo(0, 0);
        }
    };

    const {
        dismissSwish,
        featureSwitches,
        logOut,
        messagingThreads,
        member,
        profileMenu,
        systemMessages,
        systemMessageCount,
        transparentHeader
    } = props;

    const { open: profileMenuOpen = false } = profileMenu;

    const showMessagingLink = featureSwitches['messaging'];

    const { threadsUnread } = messagingThreads;

    const { redirectUrl } = profileMenu;

    return (
        <Fragment>
            <ProfileLink
                facebookId={member.facebookId}
                handleProfileClick={handleProfileClick}
                isLoggedIn={member.isLoggedIn}
                memberAlias={member.memberAlias}
                menuExpanded={profileMenuOpen === 'open'}
                systemMessageCount={systemMessageCount}
                threadsUnread={threadsUnread}
                transparentHeader={transparentHeader}
            />
            <ProfileMenu
                dismissSwish={dismissSwish}
                expanded={profileMenuOpen === 'open'}
                handleExpand={handleProfileClick}
                logOut={logOut}
                member={member}
                redirectUrl={redirectUrl}
                showMessagingLink={showMessagingLink}
                systemMessages={systemMessages}
                threadsUnread={threadsUnread}
                transparentHeader={transparentHeader}
            />
        </Fragment>
    );
};

const mapStateToProps = state => ({
    featureSwitches: state.environment.featureSwitches,
    member: state.member,
    messagingThreads: state.ui.badges.messaging,
    pageName: state.page.type,
    profileMenu: state.ui.profileMenu,
    showHeaderSearch: state.ui.showHeaderSearch,
    systemMessages: state.ui.systemMessages,
    systemMessageCount: state.ui.badges.system
});

const mapDispatchToProps = dispatch => {
    return {
        closeCategoryDropdownMenu: () =>
            dispatch(uiActions.closeCategoryDropdownMenu()),
        closeProfileMenu: () => dispatch(uiActions.closeProfileMenu()),
        dismissSwish: () => dispatch(uiActions.dismissSwish()),
        logOut: () => dispatch(uiActions.logOut()),
        openProfileMenu: () => dispatch(uiActions.openProfileMenu()),
        signIn: redirectUrl => dispatch(uiActions.signIn({ redirectUrl }))
    };
};

ProfileMenuLink.propTypes = {
    dismissSwish: PropTypes.func,
    featureSwitches: PropTypes.object,
    member: PropTypes.object,
    messagingThreads: PropTypes.object,
    pageName: PropTypes.string,
    systemMessages: PropTypes.object,
    systemMessageCount: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenuLink);
